var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex flex-column" }, [
    _c("svg", { ref: "svg", staticClass: "hide", attrs: { width: "100%" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }